"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Form.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : SelectForm.js
* Description : Ce fichier contient la définition du composant SelectForm 
*               Ce composant est une liste déroulante pour sélectionner un élément dans une liste 
*               afin de remplir un formulaire 
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* SelectForm : affiche une liste déroulante pour sélectionner un élément dans une liste afin de remplir un formulaire 
*
* Type : composant 
*
* Parametres : 
*  - error -- booléen pour remonter une erreur de validation de la sélection
*  - labelText -- texte affiché au dessus de la liste déroulante pour apporter des précisions
*  - choices -- liste des éléments présents dans la liste déroulante
*  - selectedItem -- élément sélectionnée
*  - setSelectedItem -- fonction pour mettre à jour la variable selectedItem
*/function SelectForm(_ref) {
  var error = _ref.error,
    labelText = _ref.labelText,
    choices = _ref.choices,
    selectedItem = _ref.selectedItem,
    setSelectedItem = _ref.setSelectedItem;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return error ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: screenWidth > 1000 ? 'select-form' : screenWidth > 650 ? 'select-form-ss' : 'select-form-tr',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "select-form-label",
      children: [labelText, " :"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
      name: "selectedChoice",
      className: "select-form-error",
      value: selectedItem,
      onChange: function onChange(e) {
        return setSelectedItem(e.target.value);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: 0,
        children: '--Tous--'
      }), choices.map(function (choice) {
        return choice['name'] ? /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice['name']
        }, choice['id']) : choice['reference'] ? /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice['reference']
        }, choice['id']) : choice['version'] ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
          value: choice['id'],
          children: [choice['serial_number'], " - version ", choice['version']]
        }, choice['id']) : /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice['serial_number']
        }, choice['id']);
      })]
    }), selectedItem === 0 || selectedItem === '0' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "form-error",
      children: "Ce champ est obligatoire !"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "form-error",
      children: "Cette valeur est d\xE9j\xE0 utilis\xE9e !"
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: screenWidth > 1000 ? 'select-form' : screenWidth > 650 ? 'select-form-ss' : 'select-form-tr',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "select-form-label",
      children: [labelText, " :"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
      name: "selectedChoice",
      className: "select-form-option",
      value: selectedItem,
      onChange: function onChange(e) {
        return setSelectedItem(e.target.value);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: 0,
        children: '--Tous--'
      }), choices.map(function (choice) {
        return choice['name'] ? /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice['name']
        }, choice['id']) : choice['reference'] ? /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice['reference']
        }, choice['id']) : choice['version'] ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
          value: choice['id'],
          children: [choice['serial_number'], " - version ", choice['version']]
        }, choice['id']) : /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice['serial_number']
        }, choice['id']);
      })]
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
SelectForm.propTypes = {
  error: _propTypes["default"].bool,
  labelText: _propTypes["default"].string,
  choices: _propTypes["default"].array,
  selectedItem: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  setSelectedItem: _propTypes["default"].func
};
var _default = exports["default"] = SelectForm;